import React from "react";
import classNames from "classnames";
import { ContentSkeletonProps } from "./ContentSkeleton.types";
import styles from "./ContentSkeleton.module.scss";

/**
 * ContentSkeleton组件 - 内容区域占位加载组件
 * 基于Figma设计的骨架屏占位效果
 */
const ContentSkeleton: React.FC<ContentSkeletonProps> = ({
  className,
  style,
}) => {
  return (
    <div className={classNames(styles.root, className)} style={style}>
      {/* 大矩形块 - 188px 高 */}
      <div className={classNames(styles.block, styles.blockLarge)} />

      {/* 中等矩形条 - 35px 高 */}
      <div className={classNames(styles.block, styles.blockMedium)} />

      {/* 中等矩形条 - 35px 高 */}
      <div className={classNames(styles.block, styles.blockMedium)} />

      {/* 小矩形条 - 162px 宽, 35px 高 */}
      <div className={classNames(styles.block, styles.blockSmall)} />

      {/* 大矩形块 - 185px 高 */}
      <div className={classNames(styles.block, styles.blockLarge2)} />

      {/* 大矩形块 - 185px 高 */}
      <div className={classNames(styles.block, styles.blockLarge2)} />
    </div>
  );
};

export default ContentSkeleton;
